(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6875],{

/***/ 16875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ components_ImproveYourAds_ImproveYourAds; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ./src/views/Partners/FacebookAdsPage/components/ImproveYourAds/assets/ImproveYourAds@2x.png
var ImproveYourAds_2x = __webpack_require__(32695);
var ImproveYourAds_2x_default = /*#__PURE__*/__webpack_require__.n(ImproveYourAds_2x);
// EXTERNAL MODULE: ./src/views/Partners/FacebookAdsPage/components/ImproveYourAds/assets/ImproveYourAds.webp
var ImproveYourAds = __webpack_require__(2767);
var ImproveYourAds_default = /*#__PURE__*/__webpack_require__.n(ImproveYourAds);
// EXTERNAL MODULE: ./src/views/Partners/FacebookAdsPage/components/ImproveYourAds/assets/ImproveYourAds@2x.webp
var assets_ImproveYourAds_2x = __webpack_require__(66903);
var assets_ImproveYourAds_2x_default = /*#__PURE__*/__webpack_require__.n(assets_ImproveYourAds_2x);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/Partners/FacebookAdsPage/components/ImproveYourAds/ImproveYourAdsImage.tsx








var ImproveYourAdsImage = function ImproveYourAdsImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((ImproveYourAds_default()), ", ").concat((assets_ImproveYourAds_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledImage, {
      src: (ImproveYourAds_2x_default()),
      alt: "Improve your ads",
      width: "433",
      height: "348",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var ImproveYourAds_ImproveYourAdsImage = (ImproveYourAdsImage);

var StyledImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "e6yc0mv0"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.between("xl", "xxl");
}, "{transform:translateX(80px);}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./src/views/Partners/FacebookAdsPage/components/ImproveYourAds/ImproveYourAds.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var copy = {
  overline: "Why Segment and Facebook",
  heading: "Improve your ads with the right message",
  description: "Segment enables businesses using Facebook ad products to improve their targeting and deliver relevant content to the right person, at the right time, in the right place."
};

var ImproveYourAds_ImproveYourAds = function ImproveYourAds() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSectionBase, {
      variant: "2Col",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionCopy, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledOverline, {
            tag: "h4",
            variant: "textBold",
            children: copy.overline
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            variant: "h2",
            tag: "h3",
            children: copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            variant: "pLarge",
            children: copy.description
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImproveYourAds_ImproveYourAdsImage, {})
      })]
    })
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e10rf37q3"
} : 0)("display:grid;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.down("md");
}, "{padding-top:20px;}", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("xl");
}, "{margin-top:100px;}" + ( true ? "" : 0));

var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e10rf37q2"
} : 0)( true ? {
  name: "1h8nup8",
  styles: "overflow:visible"
} : 0);

var StyledOverline = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Overline */.Lh,  true ? {
  target: "e10rf37q1"
} : 0)( true ? "" : 0);

var SectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "e10rf37q0"
} : 0)("display:flex;align-items:center;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:392px;justify-self:end;align-self:center;}" + ( true ? "" : 0));

/* harmony default export */ var components_ImproveYourAds_ImproveYourAds = (ImproveYourAds_ImproveYourAds);
;// CONCATENATED MODULE: ./src/views/Partners/FacebookAdsPage/components/ImproveYourAds/index.ts


/***/ }),

/***/ 32695:
/***/ (function(module) {

module.exports = "/_next/static/images/ImproveYourAds@2x-01654d54506d811da260634598c99356.png";

/***/ }),

/***/ 2767:
/***/ (function(module) {

module.exports = "/_next/static/images/ImproveYourAds-00372b3afbeb16b8bd03920a4bb6c9c1.webp";

/***/ }),

/***/ 66903:
/***/ (function(module) {

module.exports = "/_next/static/images/ImproveYourAds@2x-ad228fb5a121e8f97ca2e0526a0af582.webp";

/***/ })

}]);